import Select from 'Components/Select';
import Label from 'Components/Label';
import { __ } from '@wordpress/i18n';
import PropTypes from 'prop-types';

export const formOptions = [
	...eFormGTB.forms.map(form => ({
		label: `${form.name} (${form.sub})`,
		value: form.id,
	})),
];

const FormSelect = ({ onChange, value, ...selectProps }) => (
	<Label title={__('Select a form', 'ipt_fsqm')}>
		<Select
			onChange={onChange}
			options={formOptions}
			value={value}
			{...selectProps}
		/>
	</Label>
);
FormSelect.propTypes = {
	onChange: PropTypes.func.isRequired,
	value: PropTypes.objectOf(PropTypes.string),
};

FormSelect.defaultProps = {
	value: null,
};

export default FormSelect;
